export const makeTranslations = translations => (
  Object.values(translations)
    .reduce((mem, v) => ({ ...mem, ...v }), {})
)

export const DEFAULT_LOCALE = "en"
